import { WPS_PAYMENT_METHODS } from '@global/App/constants/constants';
import { IBillingInfo } from '@global/types/types';

const getPaymentMethods = (paymentInitData) => {
  return Object.keys(paymentInitData).filter((key) =>
    Object.hasOwn(WPS_PAYMENT_METHODS, key)
  );
};

export const paymentMethodSelection = (paymentInitData) => {
  const paymentMethodKeys = getPaymentMethods(paymentInitData);
  return paymentMethodKeys.length > 1 ? '' : paymentMethodKeys[0];
};

export const getPaymentMethodsCount = (paymentInitData) => {
  return getPaymentMethods(paymentInitData).length;
};

export const makeBillingInfoForPaymentMethod = (
  billingInfo: IBillingInfo,
  paymentMethod: string
) => {
  const mappedBillingInfoByPaymentMethods: Record<string, IBillingInfo> = {
    Card: billingInfo,
  };

  return mappedBillingInfoByPaymentMethods[paymentMethod];
};
